<template>
    <div>
        <!-- States what happens to the event: it is only listed after verification when the organizer chose Public. -->
        <Notification class="is-info">
            <span class="icon has-text-info"><i class="fas fa-info-circle"></i></span
            >{{ translate(props.publishOnApproval ? "event_status.review.note_public" : "event_status.review.note_private") }}
        </Notification>

        <h4 class="title is-5 mt-5 mb-1">{{ translate("event_status.review.organization_details") }}</h4>
        <p class="has-text-grey-light mb-3">{{ translate("event_status.review.notice") }}</p>

        <BillingDetailsForm v-model="formData.billingDetails" :validation-errors="billingValidationErrors" />

        <slot name="footer"></slot>
    </div>
</template>

<script setup lang="ts">
    import { computed, reactive, ref } from "vue";
    import { translate } from "../../Common/translations";
    import { BillingDetails } from "../../Api/federationsApi";
    import BillingDetailsForm from "../../Common/BillingDetailsForm.vue";
    import Notification from "../../Common/Notification.vue";

    const props = withDefaults(
        defineProps<{
            initialBillingDetails?: BillingDetails | null;
            publishOnApproval?: boolean;
        }>(),
        {
            initialBillingDetails: null,
            publishOnApproval: false,
        },
    );

    const formData = reactive<{
        billingDetails: BillingDetails;
    }>({
        billingDetails: props.initialBillingDetails
            ? { ...props.initialBillingDetails }
            : {
                  companyName: "",
                  street: "",
                  city: "",
                  postalCode: "",
                  country: "",
                  taxId: "",
              },
    });

    const validationErrors = ref<Record<string, string[]>>({});

    const billingValidationErrors = computed(() => {
        const result: Record<string, string[]> = {};
        for (const [key, value] of Object.entries(validationErrors.value)) {
            if (key.startsWith("billingDetails.")) {
                result[key.slice("billingDetails.".length)] = value;
            }
        }
        return result;
    });

    function getData() {
        return {
            billingDetails: formData.billingDetails,
        };
    }

    function setValidationErrors(errors: Record<string, string[]>) {
        validationErrors.value = errors;
    }

    function clearValidationErrors() {
        validationErrors.value = {};
    }

    defineExpose({
        getData,
        setValidationErrors,
        clearValidationErrors,
    });
</script>
